import { render } from "./TransactionManagment.vue?vue&type=template&id=56baa179&scoped=true"
import script from "./TransactionManagment.vue?vue&type=script&lang=js"
export * from "./TransactionManagment.vue?vue&type=script&lang=js"

import "./TransactionManagment.vue?vue&type=style&index=0&id=56baa179&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56baa179"]])

export default __exports__